import React from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Drawer } from 'rsuite'
import { LoaderBtn } from '../Loader/Loader-btn'
import 'rsuite/dist/rsuite.css'

function FicheDrawerComposantUseForm(props) {
  const { t } = useTranslation()
  const titleFiche = props.isEdit ? props.titleEdit : props.titleNew
  const isDefault = props.default && props.default === true

  const commonBody = (
    <>
      {props.actionsOperationsChange ? (
        <Drawer.Header className={props.headerClassName}>
          <div style={{ width: '100%' }}>
            {/* Row du haut */}
            <div
              className="d-flex justify-content-between align-items-center w-100"
              style={{ marginTop: -5 }}
            >
              <div>
                <Drawer.Title>{titleFiche}</Drawer.Title>
              </div>

              <div className="d-flex">
                {!props.noCancel && (
                  <Button
                    variant="outline-primary"
                    className="primary-outline-button ms-2"
                    onClick={props.onClose}
                  >
                    {t('cash.settings.SmartTags.fiche.buttons.back')}
                  </Button>
                )}
                {!props.isViewMode && (
                  <Button
                    variant="primary"
                    className="primary-button ms-2"
                    type="submit"
                    disabled={props.disabled === true}
                    onClick={props.click}
                  >
                    {props.loaderCreate ? (
                      <LoaderBtn />
                    ) : (
                      t('cash.referentiel.Mandats.fiche.buttons.save')
                    )}
                  </Button>
                )}
              </div>
            </div>

            {/* Row du bas */}
            <div style={{ marginLeft: -5 }}>
              {props.actionsOperationsChange}
            </div>
          </div>
        </Drawer.Header>
      ) : (
        <Drawer.Header className={props.headerClassName}>
          <Drawer.Title>{props.title ?? titleFiche}</Drawer.Title>
          {props.headerChildren}
          {!props.hideActions && (
            <Drawer.Actions>
              {!props.noCancel && (
                <Button
                  variant="outline-primary"
                  style={{ margin: '0px 0px 0px 10px' }}
                  className="primary-outline-button"
                  onClick={props.onClose}
                >
                  {t('cash.settings.SmartTags.fiche.buttons.back')}
                </Button>
              )}
              {props.rappro && (
                <Button
                  variant="light"
                  style={{ margin: '0px 0px 0px 10px' }}
                  onClick={props.rappro}
                >
                  {t('Rappro')}
                </Button>
              )}
              {props.other_buttons}
              {!props.isViewMode && (
                <Button
                  variant="primary"
                  className="primary-button"
                  style={{ margin: '0px 0px 0px 10px' }}
                  type="submit"
                  disabled={props.disabled && props.disabled === true}
                  onClick={props.click}
                >
                  {props.loaderCreate ? (
                    <LoaderBtn />
                  ) : (
                    t('cash.referentiel.Mandats.fiche.buttons.save')
                  )}
                </Button>
              )}
            </Drawer.Actions>
          )}
        </Drawer.Header>
      )}

      <Drawer.Body className={props.bodyClassName} style={{ padding: '30px' }}>
        {props.cardBody}
      </Drawer.Body>
    </>
  )
  return (
    <Drawer
      open={props.open}
      onClose={props.onClose}
      backdrop={props.backdrop}
      size={props.size}
      enforceFocus={false}
    >
      {isDefault ? (
        commonBody
      ) : (
        <form
          //  className="h-100 w-100"
          className="d-flex flex-column h-100 w-100"
          style={{ overflow: 'hidden' }}
          onSubmit={(e) => {
            props.isViewMode || props.noValidate
              ? e.preventDefault()
              : props.handleSubmit(props.onSubmit)(e)
            e.stopPropagation()
          }}
        >
          {commonBody}
        </form>
      )}
    </Drawer>
  )
}
export default FicheDrawerComposantUseForm

